import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as request from 'superagent';

import { UserData } from './models/User';
import { StudentData, emptyStudent } from './models/Student';
import * as UserActions from './actions/users';
import * as StudentActions from './actions/student';
import { checkForMinimumVersion } from './containers/Common/browserVersion';

// Public pages
import LoginStudentContainer from './containers/LoginStudent';
import SelectCampaignContainer from './containers/SelectCampaign';
import LoginTeacherContainer from './containers/LoginTeacher';
import GroupsContainer from './containers/Groups';
import CampaignContainer from './containers/Campaign';
import GroupSettingsContainer from './containers/GroupSettings';
import EvaluationContainer from './containers/Evaluation';
import PlayContainer from './containers/Play';
import { ToastContainer, toast } from 'react-toastify';
import './styles/App.scss';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RootState } from './reducers';
import BrowserVersion from "./containers/Common/browserVersion";
import ForgotPassword from './containers/Common/ForgotPassword';
import RetrievePassword from './containers/Common/retvievePassword';
import ChangeUserData from './containers/LoginTeacher/changeUserData';

interface Props {}

@connect(mapStateToProps, mapDispatchToProps)
class App extends React.Component<Props> {

	constructor (props: any) {
		super(props);

		const { userActions, studentActions } = props;

		if (localStorage.getItem('token')) {
			const userData: UserData = {
				_id: '',
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				school: ''
			};
			userActions.authenticateUser(userData);
		}

		if (localStorage.getItem('studenttoken')) {
			studentActions.authenticate(Object.assign({}, emptyStudent));
		}
	}

	componentDidMount() {
		checkForMinimumVersion();
	}

	render() {
		return (
			<div className="App">
				<Router>
					<div>
						<Route exact={true} path="/" component={LoginTeacherContainer} />
						<Route exact={true} path="/login" component={LoginStudentContainer} />
						<Route exact={true} path="/groups" component={GroupsContainer}/>
						<Route exact={true} path="/groupsettings/:id" component={GroupSettingsContainer} />
						<Route exact={true} path="/play/:campaignid/:storyid" component={PlayContainer} />
						<Route exact={true} path="/selectcampaign" component={SelectCampaignContainer} />
						<Route exact={true} path="/campaign/:id" component={CampaignContainer} />
						<Route exact={true} path="/evaluation/:id" component={EvaluationContainer} />
						<Route exact={true} path="/updatebrowser" component={BrowserVersion} />
						<Route exact={true} path="/retrievePassword/:id" component={RetrievePassword} />
						<Route exact={true} path="/testi" component={ChangeUserData} />
					</div>
				</Router>
				<ToastContainer 
					position="top-right"
					autoClose={5000}
					hideProgressBar={true}
					newestOnTop={false}
					closeOnClick={true}
					pauseOnHover={true}
				/>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		userActions: bindActionCreators(UserActions as {}, dispatch),
		studentActions: bindActionCreators(StudentActions as {}, dispatch)
	};
}

export default App;


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/App.tsx